import React, { useState, useEffect } from 'react';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelTop from './rightPanelTop';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

const ConsultNowSetting = ({
  waitingArea,
  showConsultNowSettingModal,
  updateOrView,
  isAdmin,
  updateOrInsert,
  isConsultNowEnabled,
}) => {
  let centerPanel = {};
  let title = APP.LANGUAGE.ConsultNow.TitleUpdateAndView;
  let orgName = waitingArea ? waitingArea.organisationName : '';
  var updatingWaitingAreaName = (waitingArea ? waitingArea.name : '') + ' (' + orgName + ')';
  let subtitle = updatingWaitingAreaName;
  const [currentCheckboxValue, setCurrentCheckboxValue] = useState(!!isConsultNowEnabled);

  useEffect(() => {
    setCurrentCheckboxValue(isConsultNowEnabled);
  }, [isConsultNowEnabled]);

  let rightPanel = (
    <RightPanelTop currentCheckboxValue={currentCheckboxValue} waitingArea={waitingArea} updateOrView={updateOrView} />
  );
  if (updateOrView == 'update') {
    centerPanel = (
      <CenterPanelUpdate
        setCurrentCheckboxValue={setCurrentCheckboxValue}
        currentCheckboxValue={currentCheckboxValue}
        isAdmin={isAdmin}
      />
    );
  }
  if (updateOrView == 'view') {
    centerPanel = <CenterPanelUpdate currentCheckboxValue={currentCheckboxValue} updateOrView={updateOrView} />;
  }

  return (
    <Modal
      show={showConsultNowSettingModal}
      hideWhenClickAway={false}
      className={updateOrInsert + ' waiting-area-after-call'}
    >
      <PopupHeader
        title={title}
        subtitle={subtitle}
        helpLink={window.APP.EXTERNAL_LINKS.ConsultNow.ConsultNowSettingDialog}
      />
      <div className="content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
              <RightPanelBottom isAdmin={isAdmin} />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">
              {rightPanel}
              <RightPanelBottom isAdmin={isAdmin} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConsultNowSetting;
